import createStore from "../helper"

export default createStore('organization_contacts')